/*
  Conversion statuses (one set: lead, sale, reject, upsell, registration,
  deposit, trash). Merged FIRST into TRANSLATION_MAPS in ./index.js, so
  existing translations still win. Keys are the English source.
*/

const ru = {
  "Registration": "Регистрация",
  "Deposit": "Депозит",
  "Trash": "Мусор",
};

const es = {
  "Registration": "Registro",
  "Deposit": "Depósito",
  "Trash": "Basura",
};

const pt = {
  "Registration": "Cadastro",
  "Deposit": "Depósito",
  "Trash": "Lixo",
};

const de = {
  "Registration": "Registrierung",
  "Deposit": "Einzahlung",
  "Trash": "Müll",
};

const fr = {
  "Registration": "Inscription",
  "Deposit": "Dépôt",
  "Trash": "Rebut",
};

const it = {
  "Registration": "Registrazione",
  "Deposit": "Deposito",
  "Trash": "Scarto",
};

const pl = {
  "Registration": "Rejestracja",
  "Deposit": "Depozyt",
  "Trash": "Śmieci",
};

const tr = {
  "Registration": "Kayıt",
  "Deposit": "Depozito",
  "Trash": "Çöp",
};

const uk = {
  "Registration": "Реєстрація",
  "Deposit": "Депозит",
  "Trash": "Сміття",
};

const CONVERSION_STATUSES = { ru, es, pt, de, fr, it, pl, tr, uk };
export default CONVERSION_STATUSES;
